import { desktop } from '@/lib/printTransport'
import { isBhooklyNativeServerApp } from '@/lib/bhooklyNative'

/**
 * Which shells can take an order while the link is down (F-FE-N123).
 *
 * Offline capture needs exactly one thing from its host: a fired kitchen
 * ticket must come out of the right station printer with nobody watching a
 * dialog. Two shells can do that —
 *
 *   - the Electron desktop app, through `window.bhookly.print` to a named
 *     Windows printer, and
 *   - the Bhookly Server Android app, through `window.BhooklyNative.printJobs`
 *     over a raw LAN socket to `ip:9100`, which needs no internet at all.
 *
 * A browser tab cannot, and neither can Chrome on an Android tablet: its only
 * print route is an `intent://` hand-off that requires a user gesture and caps
 * out at a URL's worth of data, so capture there would queue a ticket the
 * kitchen never receives.
 *
 * This used to be spelled `desktop() != null` at every call site, which is how
 * the tablet till was refused offline capture with a message telling the
 * cashier to go and find the desktop app. The requirement is the capability,
 * not the vendor of the shell — so it is named for the capability here and
 * asked for in one place.
 */
export function hasSilentPrintShell(): boolean {
  if (typeof window === 'undefined') return false
  return desktop() != null || isBhooklyNativeServerApp()
}
